import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { ProductsService } from '../../products.service';
import {ChangeDetectorRef} from '@angular/core';
@Component({
  selector: 'par-create-rename-favorites',
  templateUrl: './create-rename-favorites.component.html',
  styleUrls: ['./create-rename-favorites.component.scss']
})
export class CreateRenameFavoritesComponent implements OnInit {

  favNameText: string;
  duplicateName: boolean;
  maxLength: Boolean = false;

  constructor(
    public dialogRef: MatDialogRef<CreateRenameFavoritesComponent>,
    private productService: ProductsService,
    @Inject(MAT_DIALOG_DATA) public data: any, private ref: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.favNameText = this.data.renameList ? this.data.renameList.name : '';
  }

  /***************Component Methods***************/

  onClose() {
    this.dialogRef.close();
  }

  onSubmit() {
    if (this.favNameText) {
      if (this.checkDuplicate()) {
        if (!this.data.renameList) {
          this.productService.createFavList(this.favNameText.trim()).subscribe((response: any) => {
            if (!response.hasError) {
              this.dialogRef.close(response);
            }
          });
        } else {
          const request = {
            favId: this.data.renameList.favId,
            name: this.favNameText.trim()
          };
          this.productService.renameFavList(request).subscribe((response: any) => {
            if (!response.hasError) {
              this.dialogRef.close(response);
            }
          });
        }
      }
    }
  }

  checkDuplicate() {
    this.duplicateName = false;
    if (this.data.favList) {
      this.data.favList.forEach(fav => {
        if (fav.name.toLocaleLowerCase() === this.favNameText.trim().toLocaleLowerCase()) {
          this.duplicateName = true;
          this.maxLength = false;
        }
      });
    }
    return !this.duplicateName;
  }

  checkMaxLength(event) {
    this.ref.detectChanges();
    if (event.length <= 0) {
      this.maxLength = false;
    }else if (event.length > 18) {
      event = event.substring(0, 18);
      this.maxLength = true;
    }
    this.favNameText = event;
  }
}
